import { mapGetters } from 'vuex'

import { isEqual } from 'lodash'

import { MIME_TO_EXT } from '@sigma-legacy-libs/essentials/lib/constants'

import { FILE_TYPES, components, generateServices, services, states } from '@/utils'

import render from './render'

export default {
  name: 'FileManager',

  mixins: [
    generateServices({
      name: services.storage,

      find: {
        defaultFilter: {
          id: undefined,
          OwnerId: undefined,
          type: [],
          $search: undefined,
          $scope: [ 'Owner' ]
        },
        defaultPagination: { limit: 40 },
        async websocketFindCreatedEvent(instance) {
          if (!this.findData.filterIsEqualToDefault && !this.options.find.alwaysCreateFromWebSocket) {
            return
          }

          if (this.findData.filterIsEqualToDefault || this.options.find.alwaysCreateFromWebSocket) {
            this.findData.pagination.total++
          }

          let workingArray = this.findData.data
          let limit = this.findData.pagination.limit

          if (this.options.find.bucketEnabled) {
            workingArray = this.bucket

            limit = this.options.find.bucketMaxLength
          } else {
            instance = await this.options.inputFilter.call(this.ctx, instance)
          }

          if (workingArray) {
            Object.keys(FILE_TYPES).forEach(title => {
              if (title !== 'file' && ~FILE_TYPES[title].extensions.indexOf(MIME_TO_EXT[instance.type])) {
                if (this.findData.filter.type && this.findData.filter.type.length) {
                  if (~this.findData.filter.type.indexOf(FILE_TYPES[title].value)) {
                    workingArray.unshift(instance)
                  }
                }

                if (this.findData.filter.type && !this.findData.filter.type.length) {
                  workingArray.unshift(instance)
                }
              }
            })

            if (workingArray.length > limit && !this.options.find.appendMode) {
              workingArray.splice(limit)
            }

            if (workingArray === this.bucket) {
              this.findData.bucketLength = this.bucket.length
            }
          }
        },

        alwaysCreateFromWebSocket: true,
        alwaysUpdateFromWebSocket: true,
        alwaysRemoveFromWebSocket: true
      },
      create: false,

      remove: { redirect: false }
    })
  ],

  props: {
    maxFileSize: Number,
    currentChosenFileId: String,

    name: {
      type: [ String, Boolean ],
      default: 'file'
    },

    types: {
      type: Array,
      default: () => []
    },

    show: Boolean,
    readonly: Boolean,
    isPublic: Boolean,
    embedded: Boolean
  },

  data() {
    return {
      googleFileURL: undefined,
      currentEditFile: undefined,
      editDialogType: undefined,
      showEditDialog: false,
      showLoadingArea: false
    }
  },

  computed: {
    ...mapGetters({ state: 'file/state' }),

    loading() {
      return this.state === states.loading || this.restData[services.storage].find.state === states.loading
    },
    component() {
      return this.embedded ? components.dialog : components.card
    }
  },

  watch: {
    [`restData.${services.storage}.find.filter.id`](value) {
      if (!isEqual(value, this.$route.query.id)) {
        this.$router.replace({
          path: this.$route.path,
          query: { id: value }
        })
      }
    }
  },

  mounted() {
    if (this.$route.query.id) {
      this.restData[services.storage].find.filter.id = this.$route.query.id
    }
    this.rest[services.storage].find()
  },

  methods: {
    drop(event) {
      event.preventDefault()
      this.showLoadingArea = false
    }
  },

  render
}
